import condutorRepository from "./condutorRepository"
import veiculoRepository from "./veiculoRepository"
import destinoRepository from "./destinoRepository"
import jornadaRepository from "./jornadaRepository"
import pontoRepository from "./pontoRepository"
import grupoRepository from "./grupoRepository"
import motivoRepository from "./motivoRepository"
import preAgendamentoTransporteRepository from "./preAgendamentoTransporteRepository"
import parametrizacaoRepository from "./parametrizacaoRepository"
import agendarRepository from "./agendarRepository"
import supervisorRepository from "./supervisorRepository"
import escolherRepository from "./escolherRepository"
import listagemRepository from "./listagemRepository"
import transferenciaRepository from "./transferenciaRepository"
import fechamentoViagemRepository from "./fechamentoViagemRepository"
import gerenciamentoRepository from "./gerenciamentoRepository"
import reimpressaoProtocolo from "./reimpressaoProtocolo"
import relatorioAgendador from "./relatorioAgendador"
import relatorioViagemRepository from "./relatorioViagemRepository"
import relatorioEstatisticoRespository from "./relatorioEstatisticoRespository"
import relatorioQuantitativo from "./relatorioQuantitativoRepository"
import relatorioViagemVeiculoRepository from "./relatorioViagemVeiculoRepository"
import relatorioViagemMotoristaRepository from "./relatorioViagemMotoristaRepository"
import relatorioViagemGeralRepository from "./relatorioViagemGeralRepository"
import relatorioViagemDataRepository from "./relatorioViagemDataRepository"
import relatorioPrestacaoContaRepository from "./relatorioPrestacaoContaRepository"
import reaberturaViagemRepository from "./reaberturaViagemRepository"

export default baseUrl => {
    baseUrl = `${baseUrl}/transporte-paciente`

    return {
        condutor: condutorRepository(baseUrl),
        veiculo: veiculoRepository(baseUrl),
        destino: destinoRepository(baseUrl),
        jornada: jornadaRepository(baseUrl),
        ponto: pontoRepository(baseUrl),
        grupo: grupoRepository(baseUrl),
        motivo: motivoRepository(baseUrl),
        preAgendamentoTransporte: preAgendamentoTransporteRepository(baseUrl),
        parametrizacao: parametrizacaoRepository(baseUrl),
        agendar: agendarRepository(baseUrl),
        supervisor: supervisorRepository(baseUrl),
        escolher: escolherRepository(baseUrl),
        listagem: listagemRepository(baseUrl),
        transferencia: transferenciaRepository(baseUrl),
        fechamentoViagem: fechamentoViagemRepository(baseUrl),
        gerenciamento: gerenciamentoRepository(baseUrl),
        reimpressaoProtocolo: reimpressaoProtocolo(baseUrl),
        relatorioAgendador: relatorioAgendador(baseUrl),
        relatorioViagem: relatorioViagemRepository(baseUrl),
        relatorioEstatistico: relatorioEstatisticoRespository(baseUrl),
        relatorioQuantitativo: relatorioQuantitativo(baseUrl),
        relatorioViagemVeiculo: relatorioViagemVeiculoRepository(baseUrl),
        relatorioViagemMotorista: relatorioViagemMotoristaRepository(baseUrl),
        relatorioViagemGeral: relatorioViagemGeralRepository(baseUrl),
        relatorioViagemData: relatorioViagemDataRepository(baseUrl),
        relatorioPrestacaoConta: relatorioPrestacaoContaRepository(baseUrl),
        reaberturaViagem: reaberturaViagemRepository(baseUrl),
    }
}